import { Component, Input } from '@angular/core';
import { Header } from './models/header.interfaces';

@Component({
  selector: 'idp-header',
  standalone: true,
  imports: [],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() content: Header = {} as Header;
}
